import React from 'react';
import Navbar from '../layouts/navbar';
import './developers.css';

const developers =()=>{
    return(
        <React.Fragment>
            <Navbar head="Project Team"/>
            <div className="container py-5" style={{marginTop:"50px"}}>
                <div className="row">
                    <div className="col text-center">
                        <h1 className="display-4 text-dark mb-0">
                            Project Head
                        </h1>
                        <div className="" style={{height:"5px",width:"150px",margin:"0 auto",background:"#65cdf0"}}></div>
                        <p className="text-muted">Some description</p>
                    </div>
                </div>
                <div className="row">
                <div className="col-10 col-sm-8 col-lg-4 mx-auto">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Dr.Shaleen</h5>
                            </div>
                        </div>
                </div>
                </div>
                <div className="row mt-4">
                    <div className="col text-center">
                        <h1 className="display-4 text-dark mb-0">
                            Developers Team
                        </h1>
                        <div className=" " style={{height:"5px",width:"180px",margin:"0 auto",background:"#65cdf0"}}></div>
                        <p className="text-muted">Some description</p>
                    </div>
                </div>
                <div className="row">
                <div className="col-10 col-sm-8 col-lg-4 mx-auto">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Vansh</h5>
                            </div>
                        </div>
                </div>
                <div className="col-10 col-sm-8 col-lg-4 mx-auto">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Ansh</h5>
                            </div>
                        </div>
                </div>
                <div className="col-10 col-sm-8 col-lg-4 mx-auto">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Aman</h5>
                            </div>
                        </div>
                </div>
                </div>

                <div className="row">
                    <div className="col text-center">
                        <h1 className="display-4 text-dark mb-0">
                            Reasearch and Development Team
                        </h1>
                        <div className=" " style={{height:"5px",width:"250px",margin:"0 auto",background:"#65cdf0"}}></div>
                        <p className="text-muted">Some description</p>
                    </div>
                </div>
                <div className="row">
                <div className="col-10 col-sm-8 col-lg-4">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="card-title">Dr.Shaleen</h5>
                            </div>
                        </div>
                </div>
                
                <div className="col-10 col-sm-8 col-lg-4">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Dr.Shaleen</h5>
                            </div>
                        </div>
                </div>
                <div className="col-10 col-sm-8 col-lg-4">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Dr.Shaleen</h5>
                            </div>
                        </div>
                </div>
                <div className="col-10 col-sm-8 col-lg-4">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Dr.Shaleen</h5>
                            </div>
                        </div>
                </div>
                <div className="col-10 col-sm-8 col-lg-4">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Dr.Shaleen</h5>
                            </div>
                        </div>
                </div>
                <div className="col-10 col-sm-8 col-lg-4">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Dr.Shaleen</h5>
                            </div>
                        </div>
                </div>
                <div className="col-10 col-sm-8 col-lg-4">
                        <div className="card">
                        <img src="/assests/images/team-5.jpg" class="card-img-top" alt=""/>
                            <div className="card-body">
                                <h5 className="">Dr.Shaleen</h5>
                            </div>
                        </div>
                </div>
                </div>

            </div>
        </React.Fragment>
    )
}

export default developers;